import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface SecFiling {
  id: string;
  ticker: string;
  filing_type: string;
  filing_date: string;
  accepted_date: string | null;
  title: string | null;
  link: string | null;
  is_bitcoin_related: boolean;
  extracted_btc_amount: number | null;
  extracted_total_usd: number | null;
  extracted_avg_price: number | null;
  extracted_total_holdings: number | null;
  content_parsed: boolean;
  parsing_confidence: 'high' | 'medium' | 'low' | null;
  created_at: string;
}

export function useSecFilings(limit = 20) {
  return useQuery({
    queryKey: ['sec-filings', limit],
    queryFn: async (): Promise<SecFiling[]> => {
      const { data, error } = await supabase
        .from('sec_filings_history')
        .select('*')
        .order('filing_date', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return (data as SecFiling[]) || [];
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useBtcRelatedFilings(limit = 10) {
  return useQuery({
    queryKey: ['btc-filings', limit],
    queryFn: async (): Promise<SecFiling[]> => {
      const { data, error } = await supabase
        .from('sec_filings_history')
        .select('*')
        .eq('is_bitcoin_related', true)
        .order('filing_date', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return (data as SecFiling[]) || [];
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useBtcAcquisitions(limit = 10) {
  return useQuery({
    queryKey: ['btc-acquisitions', limit],
    queryFn: async (): Promise<SecFiling[]> => {
      const { data, error } = await supabase
        .from('sec_filings_history')
        .select('*')
        .eq('is_bitcoin_related', true)
        .not('extracted_btc_amount', 'is', null)
        .order('filing_date', { ascending: false })
        .limit(limit);

      if (error) throw error;
      return (data as SecFiling[]) || [];
    },
    staleTime: 5 * 60 * 1000,
  });
}
